import { render, staticRenderFns } from "./PaidMessaging.vue?vue&type=template&id=f67caa52&scoped=true&"
import script from "./PaidMessaging.vue?vue&type=script&lang=js&"
export * from "./PaidMessaging.vue?vue&type=script&lang=js&"
import style0 from "./PaidMessaging.vue?vue&type=style&index=0&id=f67caa52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67caa52",
  null
  
)

export default component.exports